import React, { ReactNode } from "react";
import { GaFooter } from "../footer";

interface LayoutProps {
    children: ReactNode;
}

export const GaLayout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="flex flex-col min-h-screen">
            <main className="flex-grow bg-gray-200">{children}</main>
            <GaFooter />
        </div>
    );
};
